import React, { memo, useEffect, useState } from 'react'
import { useAppSelector } from 'store';
import Countdown from './Coundown';

const CountdownState = (props: any) => {
    const [countdownDate, setCountdownDate] = useState<any>(null);
    const { user, appGlobal } = useAppSelector((state) => state.app) as any;
    const getPackge = (betId: any) => {
        if (appGlobal.PACKAGE?.length > 0) {
            const data = appGlobal?.PACKAGE?.find((i: any) => betId === i?._id);
            console.log(data);

            return data;
        }
    };



    useEffect(() => {
        if (props?.transaction_status === 'pending') {
            setCountdownDate(new Date(props?.i?.createdAt).getTime() + parseInt(getPackge(props?.i?.bet_id)?.time) * 1000);
        }
    }, [props]);
    return (
        <>
            {
                countdownDate && <Countdown
                    onComplete={props?.getHistory}
                    date={countdownDate}

                />
            }

        </>
    )
}

export default memo(CountdownState);